export enum AUTH_STATUS {
  LOGGED_IN = 'LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
  UNDETERMINED = 'UNDETERMINED',
}

const ROLE_TYPES = ['CODE_CONTROL', 'XPM_ADMIN', 'REVIEWER','QUALITY_CONTROL'] as const;
type Role = typeof ROLE_TYPES;
export type IRole = Role[number];

export function isRole(value: string): value is IRole {
  return ROLE_TYPES.includes(value as IRole);
}

export const extractRoles = (roles: unknown) => {
  if (Array.isArray(roles)) {
    const filtered: IRole[] = roles.filter((role: unknown) => {
      if (typeof role === 'string') {
        return isRole(role);
      } else {
        return false;
      }
    });
    return filtered;
  } else {
    return [];
  }
};
